import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRecordFurtherEducationGroupEditItem extends IEditItem {
    code: string;
    comment: string;
    requiredQualificationCount: number;
    modifyUser: IModifyUser;
}

export class RecordFurtherEducationGroupEditItem extends EditItem implements IRecordFurtherEducationGroupEditItem {
    code: string;
    comment: string;
    requiredQualificationCount: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IRecordFurtherEducationGroupEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}